export default "__VITE_ASSET__Ewa_TmhE__"